export interface IPromisedPaymentBalance {
    payForDay: number,
    day: unknown,
    /**
     * Дата конца активности ОП (вернется, если есть активный ОП)
     */
    activeTo: string | null,
    activeToTimestamp: unknown,
    activeToIsoNoOffset: string | null,
    activeFromIsoNoOffset: string | null,
    activeFromTimestamp: number | null,
    auto: unknown,
    critDay: number | null,
    /**
     * Показывает стоимость ОП
     */
    isFree: 0 | 1 | null,

    /**
     * Дата, с которой подключается ОП (вернется, если доступен)
     * Дата, с которой активен ОП (вернется, если есть активный ОП)
     */
    activeFrom: string | null,

    /**
     * Подключен ли ОП
     */
    isActive: 0 | 1,
}

export interface IPromisedPaymentInfo {
    code: string | null,
    promisedPaymentBal: IPromisedPaymentBalance,
}

export interface IBindingCard {
    id: number,
    maskedNumber: string,
    numberWithPaySystem?: string,
    autoPayStatus: boolean,
    autopayText?: string,
    comingPayDay: string,
    payDay: number,
    paySystem?: string,
    canPayCredit?: boolean,
}

export interface IAlertButton {
    text: string,
    url: string,
}

export interface IAlert {
    text: string,
    type: 'info' | 'error',
    buttons: IAlertButton[],
}

export interface IPaymentInfo {
    balance: number,
    paySum: number,
    payDay: string,
    bindingCards: IBindingCard[],
    promisedPayment: unknown[] | null,
    promisedPaymentInfo: IPromisedPaymentInfo,
    payText: string,
    payChargesSum: string,
    payTextParam: string,
    payPeriodDates: string,
    payCurBalance: string,
    payIsDeny: boolean,
    payTextShort: string,
    alert?: IAlert,

    agreementClosingDate?: string | null,
    payDayShort?: string | null,
    payChargesSumShort?: number | null,
}

export interface ITerminalResources {
    id: number,
    name: string,
    serviceId: number,
    type: string,
}

/**
 * Статус приостановления сервиса
 *  + 0 - нет приостановления
 *  + 1 - приостановлено клиентом или АО
 *  + 2 - приостановлено биллингом по ДЗ
 */
export enum ESuspendStatus {
    Active = 0,
    SuspendedByClient = 1,
    SuspendedByBilling = 2,
}

export interface IServices {
    productId: number,
    productName: string,
    planId: number,
    planName: string,
    specification: number,
    activated: 0 | 1,
    activateDateFrom: unknown,
    activateDateTo: unknown,
    terminalResources: ITerminalResources[],
    suspendStatus: ESuspendStatus,
}

export interface ITariffActivation {
    isNeeded: 0 | 1 | boolean,
    dateFrom: string | null,
    dateTo: string | null,
}

export interface IWidgetData {
    imageBackground: string,
    imageBackgroundWebp: string,
    textColor: string,
}

export interface IProducts {
    tariffPriceMvno: number,
    salePackageId: number,
    tariffPrice: number,
    tariffPriceWithSale: number,
    tariffName: string,
    tariffPriceDiscount: number,
    services: IServices[],
    widgetData: IWidgetData | null,
    tariffActivation: ITariffActivation,
    isConstructor: boolean,
    alert?: IAlert,
}

export interface IPersonal {
    address: {
        city: string,
        street: string,
        streetId: number,
        house: number,
        building: string,
        flat: number,
    },
    agreement: number,
    agreementId: number,
    agreementTypeId: number,
    billingCity: {
        domain: string,
        providerId: number,
    },
    cityId: number,
    fio: string,
    photoUrl: string,
}

export enum EContactStatuses {
    confirmed = 'confirmed',
    unconfirmed = 'unconfirmed'
}

export interface IContact {
    id: number,
    contactValue: string,
    status: EContactStatuses,
}

export interface IPhoneContact extends IContact {
    phoneTypeId: number,
    needUpdate?: boolean,
}

export interface IContacts {
    email: IContact[],
    phone: IPhoneContact[],
}

export interface ResponseContactDto {
    contacts: { contacts: IContacts },
    personal: IPersonal,
    products: IProducts,
    payment: IPaymentInfo,
}
